import { dataLayer } from '@src/services/dataLayer';
import { sessionStorageHelper } from '@src/utils/session-storage-utils';

/** Returns device type from userAgent for analytics context (e.g. virtual_page_view). */
export function getDeviceType(userAgent: string): 'mobile' | 'desktop' {
	return /mobile/i.test(userAgent) ? 'mobile' : 'desktop';
}

export const fireDataLayerEvent = (key: string, eventData: Record<string, any>) => {
	if (sessionStorageHelper.getKey(key) !== 'true') {
		dataLayer(eventData);
		sessionStorageHelper.setKey(key, 'true');
	}
};
